var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Flex from "@irati/ui/src/Flex";
import { H3 } from "@irati/ui/src/Headings";
import Icon from "@irati/ui/src/Icon";
import { Label3, Para } from "@irati/ui/src/Labels";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import IconWrapper from "../IconWrapper";
import { AdminCard, ButtonWrapper, ColorHr, MarginLeft, RouterLink } from "./styled";
var LargeAdminCard = /** @class */ (function (_super) {
    __extends(LargeAdminCard, _super);
    function LargeAdminCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LargeAdminCard.prototype.render = function () {
        var _a = this.props, headingTextKey = _a.headingTextKey, descriptionTextKey = _a.descriptionTextKey, children = _a.children, _b = _a.pill, pill = _b === void 0 ? null : _b, iconType = _a.iconType, iconColor = _a.iconColor, linkTo = _a.linkTo, tracking = _a.tracking;
        return (React.createElement(AdminCard, null,
            React.createElement(RouterLink, { to: linkTo, onClick: tracking, plain: true },
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(Flex, { alignItems: "center" },
                        React.createElement(IconWrapper, { color: iconColor },
                            React.createElement(Icon, { size: "55", icon: iconType })),
                        React.createElement(H3, null,
                            React.createElement(FormattedMessage, { id: headingTextKey }))),
                    pill && (React.createElement(Flex, { minWidth: "100px", alignItems: "baseline", justifyContent: "flex-end" }, pill())))),
            React.createElement(ColorHr, null),
            React.createElement(Flex, { direction: "column", height: "100%" },
                React.createElement(Para, { marginBottom: 2 },
                    React.createElement(FormattedMessage, { id: descriptionTextKey })),
                children && (React.createElement(Label3, { small: true, uppercase: true },
                    React.createElement(FormattedMessage, { id: "admin.dashboard.smallCard.quickActions" }))),
                React.createElement(Flex, { justifyContent: "space-between", alignItems: children ? "center" : "flex-end", height: "100%" },
                    children && React.createElement(ButtonWrapper, null, children),
                    React.createElement(MarginLeft, { to: linkTo, onClick: tracking, plain: true },
                        React.createElement(Icon, { size: "25px", icon: "rightArrow" }))))));
    };
    return LargeAdminCard;
}(PureComponent));
export default injectIntl(LargeAdminCard);
